<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="card">
            <div class="card-body mb-0 pb-0">
                <TabNavigation v-model="activeTab" :tabs="tabs" />
                <ProductListing v-if="activeTab == 'products'" class="fade-in" />
                <OrderListing v-else-if="activeTab == 'orders'" class="fade-in" />
                <ProductCategoryListing v-else-if="activeTab == 'productCategory'" class="fade-in" />
                <ProductConditionListing v-else-if="activeTab == 'productCondition'" class="fade-in" />
            </div>
        </div>
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import TabNavigation from '@/components/customTopNav';
import ProductListing from '@/views/pages/admin/product/productListing';
import OrderListing from '@/views/pages/admin/order/orderListing';
import ProductCategoryListing from '@/views/pages/admin/productCategory/productCategoryListing';
import ProductConditionListing from '@/views/pages/admin/productCondition/productConditionListing';

export default {
    page: {
        title: i18n.t("module.marketplace"),
    },
    components: { Layout, PageHeader, TabNavigation, ProductListing, OrderListing, ProductCategoryListing, ProductConditionListing },
    created() {
        this.changeTabFromQuery();
    },
    watch: {
        '$route.query.tab'() {
            this.changeTabFromQuery();
        },
    },
    methods: {
        changeTabFromQuery() {
            this.activeTab = this.tabs.find(item => item.id == this.$route.query.tab)?.id || 'products';
        },
    },
    data() {
        return {
            title: i18n.t("module.marketplace"),
            activeTab: 'products',
            tabs: [
                { id: 'products', name: i18n.t('module.products'), icon: 'mdi-package-variant' },
                { id: 'orders', name: i18n.t('module.orders'), icon: 'mdi-cart-outline' },
                { id: 'productCategory', name: i18n.t('module.productCategory'), icon: 'mdi-shape' },
                { id: 'productCondition', name: i18n.t('module.productCondition'), icon: 'mdi-tag-outline' },
            ],
            items: [
                {
                    text: i18n.t("module.marketplace"),
                    active: true,
                },
            ],
        };
    },
}
</script>